import { useQuery } from '@tanstack/react-query';
import klydoApiClient from '../../../api/klydo';

/**
 * Returns whether the current user has any klydos at all.
 * Used to detect first-time creators (no klydos yet).
 */
const useHasAnyKlydosQuery = (enabled = true) => {
  return useQuery<boolean, Error>({
    queryKey: ['hasAnyKlydos'],
    queryFn: async () => {
      const res = await klydoApiClient.search('', { limit: 1, skip: 0 });
      return res.length > 0;
    },
    enabled,
  });
};

export default useHasAnyKlydosQuery;
